import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon } from '@rossum/ui/material';

type Props = {
  onClick: () => void;
  isSidebarOpen: boolean;
};

export const ToggleSidebarButton = ({ isSidebarOpen, onClick }: Props) => {
  const SidebarIcon = isSidebarOpen
    ? IconLayoutSidebarLeftCollapse
    : IconLayoutSidebarLeftExpand;

  return (
    <IconButton onClick={onClick}>
      <SvgIcon fontSize="large" color="secondary">
        <SidebarIcon />
      </SvgIcon>
    </IconButton>
  );
};
